exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".help-text[data-v-bef4aabc] {\n  text-align: center;\n  background-color: #209cee;\n  color: white;\n  padding: 5px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n.help[data-v-bef4aabc] {\n  text-align: right;\n  position: relative;\n}\n", ""]);
